export default __webpack_public_path__ + "static/media/cardinal_white.abc22523.svg";